import { useTranslation } from "react-i18next";
import { useScreenWidth } from "../ScreenWidthContext";
import { toCoverLinks } from "./subcomponent/GetStarted/AnimCard";
import players from "../assets/img/presentation/Spieleranzahl.svg";
import duration from "../assets/img/presentation/Dauer.svg";
import classgrade from "../assets/img/presentation/Klassenstufe.svg";
import location from "../assets/img/presentation/Ort.svg";
import DoubleArrowDown from "./subcomponent/DoubleArrowDown";
import { createArrays, options, step } from "./subcomponent/GetStarted/Keyframer";
import { useEffect } from "react";

let data = createArrays();

function Presentation() {
    const screenWidth = useScreenWidth();
    const { t } = useTranslation(["presentation"]);

    const links = toCoverLinks("Der Fall Finova");

    const points = [
        {
            "icon": players,
            "firstline": t("description.players").replaceAll("{0}", "4-5"),
            "secondline": t("description.players_subline")
        },
        {
            "icon": duration,
            "firstline": t("description.minutes").replaceAll("{0}", "90-180"),
            "secondline": ""
        },
        {
            "icon": classgrade,
            "firstline": t("description.class").replaceAll("{0}", "4.-13."),
            "secondline": t("description.class_subline")
        },
        {
            "icon": location,
            "firstline": t("description.location"),
            "secondline": ""
        }
    ];

    const makeKeyframes = (mul) => {
        let keyframes = [];
        let keyframe;
        let [pos, vel] = data;
        for (let i = 0; i < 100; ++i) {
            [keyframe, pos, vel] = step(pos, vel, mul);
            keyframes.push(keyframe);
        }
        data = [pos, vel];
        return keyframes;
    }

    const animate = (c, mul=1) => {
        let anim = c.animate(makeKeyframes(mul), options);
        anim.onfinish = () => {
            animate(c, mul);
        };
    };

    useEffect(() => {
        let card = document.getElementById("presentationcard");
        if (card) {
            animate(card, 0.6);
        }
    }, []);

    return screenWidth < 950 && (
        <div id="a-presentation" className="presentation-content">
            <div className="presentation-headline">{t("headline")}</div>
            <div className="presentation-card" id="presentationcard">
                <img className="pcardmain" src={links[0]} />
                <img className="pcardover" src={links[1]} />
            </div>
            <h2 className="presentation-poster-name">{t("showcase_poster_name")}</h2>
            <p className="presentation-description">{t("teaser")}</p>
            <div className="presentation-points">
                {
                    Array.from(points, (p, i) => {
                        return (
                            <div className="point">
                                <img src={p["icon"]} />
                                <p className="firstline">{p["firstline"]}</p>
                                <p className="secondline">{p["secondline"]}</p>
                            </div>
                        );
                    })
                }
            </div>
            <DoubleArrowDown className="presentation-dad" onClick={() => {
          document.getElementById("a-tourplanner").scrollIntoView();
        }}>{t("configure")}</DoubleArrowDown>
        </div>
    );

}

export default Presentation;